/* ============================================================================
   SG-2026 · <sg-cart-total> Custom Element
   ----------------------------------------------------------------------------
   Zeigt den "echten" Gesamtbetrag als Summe aus Zwischensumme + Versand.
   Hintergrund: Shopify kennt den Versandpreis erst im Checkout — cart.total_price
   in Liquid enthaelt daher nur die Zwischensumme. Wir berechnen den Versand
   live via <sg-shipping-price> und addieren ihn hier dazu.

   DOM:
     <sg-cart-total data-base-cents="48900" data-currency="EUR">489,00 €</sg-cart-total>

   Hoert auf:
     - 'sg:cart-total:update' (detail.shippingCents)
   ============================================================================ */

(function () {
  'use strict';

  if (customElements.get('sg-cart-total')) return;

  class SgCartTotal extends HTMLElement {
    constructor() {
      super();
      this._onUpdate = this._onUpdate.bind(this);
    }

    connectedCallback() {
      this._base = parseInt(this.dataset.baseCents, 10) || 0;
      this._shipping = 0;
      this._currency = this.dataset.currency || 'EUR';
      this._initialText = this.textContent;

      document.addEventListener('sg:cart-total:update', this._onUpdate);

      // Initial: Wenn sgShippingRates direkt einen Wert liefern kann, nehmen
      if (window.sgShippingRates && typeof window.sgShippingRates.getRates === 'function') {
        window.sgShippingRates.getRates().then(rates => {
          if (!rates || !Array.isArray(rates) || rates.length === 0) return;
          var cheapest = rates.slice().sort((a, b) => a.price - b.price)[0];
          this._shipping = cheapest.price || 0;
          this._render();
        }).catch(() => { /* swallow */ });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('sg:cart-total:update', this._onUpdate);
    }

    _onUpdate(e) {
      var s = e && e.detail && typeof e.detail.shippingCents === 'number'
        ? e.detail.shippingCents
        : 0;
      this._shipping = s || 0;
      this._render();
    }

    _render() {
      var total = (this._base || 0) + (this._shipping || 0);
      this.textContent = this._formatMoney(total);
    }

    _formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        try {
          return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
        } catch (e) { /* fallthrough */ }
      }
      var amount = cents / 100;
      try {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: this._currency || 'EUR',
          minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (e) {
        return amount.toFixed(2) + ' €';
      }
    }
  }

  customElements.define('sg-cart-total', SgCartTotal);
})();
